<template>
  <div id="header-launcher-module">
    <div id="logo">
      <Media
        type="organization_logo"
        :media="entranceConfig.organizationLogoName"
        :entranceConfig="entranceConfig"/>
    </div>
    <span id="header-residence" :class="residenceNameSize">
      {{ entranceConfig.residenceNameToDisplay || entranceConfig.residenceName }}
    </span>
    <span id="header-clock" :class="[ connectionError ? connectionError : '' ]">
      {{ clock | time }}
    </span>
  </div>
</template>

<style lang="sass" scoped>
#header-launcher-module
  align-items: center
  background-color: rgba(0,0,0,.25)
  box-shadow: none
  color: #fff
  display: flex
  justify-content: center
  position: relative

#header-residence
  font-family: 'RobotoRegular'
  &.normal
    font-size: 1.4em
  &.small
    font-size: 1.1em

#header-clock
  align-items: center
  border-right: 8px solid #2e7d32
  display: flex
  font-family: 'RobotoLight'
  font-size: 1.4em
  justify-content: center
  height: 3.1rem
  padding-right: .9rem
  position: absolute
  right: 1rem
  &.server
    border-right-color: #ff6f00
  &.internet
    border-right-color: #b71c1c

#logo
  height: 88px
  left: 1rem
  position: absolute
  width: auto
</style>

<script>
import Media from '@/components/appModules/Media';
export default {
  name: 'ResidenceHeader',

  components: {
    Media,
  },

  props: {
    config: Object,
    entranceConfig: Object,
    clock: Date,
    connectionError: String,
  },

  data() {
    return {
    };
  },

  computed: {
    residenceNameSize() {
      let size;
      if (this.$props.entranceConfig.residenceName.length > 16) size = 'small';
      else size = 'normal';
      return size;
    },

    organizationLogo() {
      const localServerUrl = process.env.VUE_APP_TOOLS_URL;
      const img = new Image();
      let url;

      img.onload = () => {
        document.getElementById('logo')
          .src = `${localServerUrl}/ol${this.entranceConfig.organizationLogoName}`;
        url = `${localServerUrl}/ol${this.entranceConfig.organizationLogoName}`;
      };

      img.onerror = () => {
        console.log('L\'image n\'existe pas');
        this.processOrganizationLogo();
      };

      img.src = `${localServerUrl}/ol${this.entranceConfig.organizationLogoName}`;

      return url;
    },
  },

  methods: {
    processOrganizationLogo() {
      if (window.navigator.onLine) {
        const deviceID = JSON.parse(localStorage.getItem('initConfig')).deviceID;
        const serverUrl = JSON.parse(localStorage.getItem('initConfig')).serverUrl;
        const img = new Image();

        img.onload = () => {
          document.getElementById('logo')
          .src = `${serverUrl}/api/get/organization/logo/${deviceID}?v=${Date.now()}`;
          this.$store.dispatch('cacheFile', {
            fileUrl:
              `${serverUrl}/api/get/organization/logo/${deviceID}?v=${Date.now()}`,
            fileName: `ol${this.entranceConfig.organizationLogoName}`,
          });
        };

        img.onerror = () => {
          console.log('Une erreur s\'est produite');
        };

        img.src = `${serverUrl}/api/get/organization/logo/${deviceID}?v=${Date.now()}`;
      } else {
        console.log('Pas de connexion internet');
      }
    },
  },

  filters: {
    time(val) {
      const options = {
        hour: 'numeric',
        minute: 'numeric',
      };
      return val
        ? new Intl.DateTimeFormat('fr-FR', options).format(val)
        : '.';
    },
  },
};
</script>
